// src/core/lib/api/parse.ts — /v1/parse endpoint client (PRI-291 → PRI-439 R13)
// Calls POST /v1/parse (public, already convergent per §25.1) via the SDK
// transport to convert NL prompt → CompiledQuery JSON.

import { sdk } from './sdk'
import { PrimateError } from '@primate-intelligence/sdk/browser'
import type { CompiledQuery } from '../../components/v2/compiled-query-types'

export interface ParseResponse {
  compiled_query: CompiledQuery
  parse_mode: 'haiku' | 'heuristic'
}

export async function parsePrompt(prompt: string, signal?: AbortSignal): Promise<ParseResponse> {
  try {
    return await sdk.http.requestRaw<ParseResponse>('POST', '/v1/parse', {
      body: JSON.stringify({ prompt }),
      headers: { 'Content-Type': 'application/json' },
      signal,
    })
  } catch (e) {
    if (e instanceof PrimateError) {
      if (e.status === 422) {
        throw Object.assign(new Error('parse_failed'), { status: 422 })
      }
      throw Object.assign(new Error(e.rawMessage || `Parse failed: ${e.status}`), { status: e.status })
    }
    throw e
  }
}

/** Smart paste detection: returns a CompiledQuery if the text is valid compiled query JSON */
export function isCompiledQueryJSON(text: string): CompiledQuery | null {
  try {
    const obj = JSON.parse(text.trim())
    if (obj && typeof obj.query_type === 'string' && Array.isArray(obj.search_terms)) {
      return obj as CompiledQuery
    }
  } catch { /* not JSON */ }
  return null
}
